import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "rdx";

type ToggleZendeskChatbotResultT = {
  isChatbotOpen: boolean;
  toggleChatbot: (shouldEnable?: boolean) => void;
  zendeskObjectLoaded: boolean;
};

export default function useToggleZendeskChatbot(): ToggleZendeskChatbotResultT {
  const dispatch = useDispatch();
  const isChatbotOpen = useSelector(selectors.selectIsZendeskChatbotOpen);
  const isZendeskAuthenticated = useSelector(selectors.selectIsZendeskAuthenticated);
  const zendeskObjectLoaded = !!window?.zE;

  const toggleChatbot = useCallback(
    (shouldEnable = !isChatbotOpen) => {
      if (window?.zE && isZendeskAuthenticated) {
        if (shouldEnable) {
          window.zE("messenger", "show");
          window.zE("messenger", "open");
        } else {
          window.zE("messenger", "hide");
        }
        dispatch(actions.setIsZendeskChatbotOpen(shouldEnable));
      }
    },
    [isChatbotOpen, isZendeskAuthenticated, dispatch],
  );

  return { toggleChatbot, isChatbotOpen, zendeskObjectLoaded };
}
